import { RendererClient } from '@fullstory/renderer-react';
import React from 'react';

export enum PreviewState {
  INACTIVE,
  NOT_FOUND,
  LOADING,
  ACTIVE,
}

export interface PreviewContextType {
  state: PreviewState;
  setState: (state: PreviewState) => void;
  rendererClient: RendererClient | null;
  setRendererClient: (client: RendererClient | null) => void;
}

export const PreviewContext = React.createContext<PreviewContextType>({
  state: PreviewState.INACTIVE,
  setState: () => {},
  rendererClient: null,
  setRendererClient: () => {},
});
